import { render, staticRenderFns } from "./AddressRequirementsBreakDialog.vue?vue&type=template&id=71e2e0c6&scoped=true&lang=pug&"
import script from "./AddressRequirementsBreakDialog.vue?vue&type=script&lang=ts&"
export * from "./AddressRequirementsBreakDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e2e0c6",
  null
  
)

export default component.exports